import { CurrentUserStore } from '../../@Component/Domain/User/CurrentUserStore';


export default function getAmplitudeUserId(currentUserStore: CurrentUserStore): string
{
    const organisationName = currentUserStore.currentOrganization === undefined ? "[no organisation]" : currentUserStore.currentOrganization.name;

    return currentUserStore ? `Tribe CRM - ${organisationName} - ${currentUserStore.employeeEntity.id}` : null
}